module.exports = __webpack_public_path__ + "static/media/WEBnegro_59.6956658f.png";